import React, { useState } from "react";
import TokenDashboard from "./TokenDashboard";
import { getTodayIST } from "../../utils/dateUtils";
import RevenueDashboard from "./RevenueDashboard";

export default function Dashboard({
  appointments = [],
  tokens = [],
  patients = [],
  treatments = [],
  packagePayments = [],
  packages = [], 
}) {
   console.log("Dashboard Tokens:", tokens.length);
  const [viewType, setViewType] = useState("tokens");

  const todayDate = getTodayIST();

  const toJSDate = (val) => {
    if (!val) return null;
    return val.toDate ? val.toDate() : new Date(val);
  };

  // Appointments logic
  const bookedToday = appointments.filter((a) => {
    const createdAt = toJSDate(a.createdAt);
    return (
      createdAt &&
      createdAt.toISOString().split("T")[0] === todayDate
    );
  });

  const scheduledToday = appointments.filter(
    (a) => a.date === todayDate
  );

  const countByStatus = (status) =>
    appointments.filter((a) => a.status === status).length;

  const appointmentStats = [
    {
      label: "Booked Today",
      color: "bg-blue-100 text-blue-800",
      count: bookedToday.length,
    },
    {
      label: "Scheduled",
      color: "bg-indigo-100 text-indigo-800",
      count: scheduledToday.length,
    },
    {
      label: "Confirmed",
      color: "bg-green-100 text-green-800",
      count: countByStatus("Confirmed"),
    },
    {
      label: "Pending",
      color: "bg-yellow-100 text-yellow-800",
      count: countByStatus("Pending"),
    },
    {
      label: "Canceled",
      color: "bg-red-100 text-red-800",
      count: countByStatus("Canceled"),
    },
    {
      label: "Rescheduled",
      color: "bg-purple-100 text-purple-800",
      count: countByStatus("Rescheduled"),
    },
  ];

  return (
    <div className="w-full">
      {/* 🔥 Responsive Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-5">
        <h2 className="text-xl sm:text-2xl font-bold text-[#204080]">
          {viewType === "appointments"
            ? "Appointments Dashboard"
            : "Token Dashboard"}
        </h2>

        {/* 🔥 Full width on mobile */}
        <select
          value={viewType}
          onChange={(e) => setViewType(e.target.value)}
          className="w-full sm:w-auto border rounded-lg px-3 py-2 text-sm shadow-sm bg-white"
        >
          <option value="tokens">Tokens</option>
          <option value="appointments">Appointments</option>
          
        </select>
      </div>

      {/* 🔥 Conditional Rendering */}
      {viewType === "appointments" ? (
        <div
          className="
            grid 
            grid-cols-2 
            sm:grid-cols-2 
            md:grid-cols-3 
            lg:grid-cols-3 
            gap-3 sm:gap-4 
            mb-6 sm:mb-10
          "
        >
          {appointmentStats.map((s) => (
            <div
              key={s.label}
              className={`
                flex flex-col items-center justify-center
                py-3 sm:py-4 
                rounded-xl 
                ${s.color} 
                shadow-sm 
                text-center
                min-h-[90px] sm:min-h-[110px]
              `}
            >
              <p className="text-[11px] sm:text-sm font-medium">
                {s.label}
              </p>
              <p className="text-lg sm:text-2xl font-bold mt-1">
                {s.count}
              </p>
            </div>
          ))}
        </div>
      ) : (
        <div className="w-full">
          <TokenDashboard tokens={tokens} patients={patients} treatments={treatments}  packagePayments={packagePayments}  packages={packages}/>
        </div>
      )}
    </div>
  );
}
